import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, Button, Grid } from "@mui/material";
import Settings from "../../assets/images/Settings.svg";
import Scale from "../../assets/images/Scale.svg";
import { useAuth } from "../../auth/AuthContext";
import { API_PATH } from "../../environments";

const domains = ["DevOps", "SRE"];

export default function LandingPage() {
  const navigate = useNavigate();

  const getDomainIcon = (domain) => {
    if (!domain) return null;

    return domain.toLowerCase() === "devops" ? Scale : Settings;
  };
  const { user } = useAuth();
  const [evaluationList, setEvaluationList] = useState();
  const [error, setError] = useState();
  const [loading, setLoading] = useState();
  useEffect(() => {
    if (!user?.email) return;

    const fetchEvaluationList = async () => {
      try {
        const email = encodeURIComponent(user.email);
        const response = await fetch(
          `${API_PATH}/evaluations/scores/by-email?emailId=${email}`,
          {
            credentials: "include",
          },
        );

        if (!response.ok) {
          throw new Error("Failed to fetch evaluation scores");
        }

        const data = await response.json();
        const indexedData = data
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
          .map((item, index) => ({
            index: index + 1,
            ...item,
          }));
        setEvaluationList(indexedData);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchEvaluationList();
  }, [user]);
  const latestByDomain =
    evaluationList &&
    evaluationList.reduce((acc, item) => {
      const domain = item.domain;

      if (
        !acc[domain] ||
        new Date(item.createdAt) > new Date(acc[domain].createdAt)
      ) {
        acc[domain] = item;
      }

      return acc;
    }, {});

  const getDomainIconStyle = (domain) => {
    if (!domain) return {};
    return domain.toLowerCase() === "devops"
      ? { width: "32.003px", height: "31.999px" }
      : { width: "30.47px", height: "32px" };
  };

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        mt: "0px",
        overflowY: "auto",
        overflowX: "hidden",
        boxSizing: "border-box",
      }}
    >
      {/* Welcome card */}

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "flex-start",
          gap: "0.5rem",
          alignSelf: "stretch",
          padding: "20px 16px",
          borderRadius: "1rem",
          border: "1px solid #C0C7CF",
          backgroundColor: "#FFF",
          margin: "10px 16px",

          boxSizing: "border-box",
          boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
        }}
      >
        <Typography
          sx={{
            color: "#3C4044",
            fontFeatureSettings: "'liga' off, 'clig' off",
            fontFamily: "Akkurat-Bold",
            fontSize: { xs: "1.1rem", md: "24px" },
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "normal",
          }}
        >
          Welcome to the DevOps and SRE Assessment Portal.{" "}
        </Typography>

        <Typography
          sx={{
            color: "#3C4044",
            fontFeatureSettings: "'liga' off, 'clig' off", // ✅ same as CSS
            fontFamily: "Akkurat",
            fontSize: "0.875rem",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "normal",
            alignSelf: "stretch", // ✅ same property applied
          }}
        >
          You will answer a series of questions to receive your assessment
          rating. Please answer to the best of your ability to ensure accurate
          results.
        </Typography>
      </Box>
      {/* ROW 1 → TWO CARDS SIDE-BY-SIDE */}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
          gap: 2,
          padding: "16px 16px",
        }}
      >
        {/* ---------------- LEFT CARD (Completed Domain) ---------------- */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "0.8rem",
            padding: "1.25rem",
            borderRadius: "1rem",
            border: "1px solid #C0C7CF",
            backgroundColor: "#FFF",
            boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
          }}
        >
          {/* DOMAIN ICON */}
          <Box
            component="img"
            src={getDomainIcon("Devops")}
            alt={`Devops icon`}
            sx={getDomainIconStyle("Devops")}
          />

          <Typography
            sx={{
              fontFamily: "Akkurat-Bold",
              fontSize: { xs: "1.1rem", md: "24px" },
              fontWeight: 400,
              color: "#3C4044",
            }}
          >
            DevOps Assessment
          </Typography>

          {/* <Typography
            sx={{
              fontFamily: "Akkurat",
              fontSize: "20px",
              fontWeight: 400,
              color: "#3C4044",
            }}
          >
            DevOps assessment completed successfully{" "}
          </Typography> */}

          <Typography
            sx={{ fontSize: "14px", color: "#3C4044", fontFamily: "Akkurat" }}
          >
            The DevOps Assessment evaluates how effectively your organization
            integrates development and operations practices to deliver software
            rapidly, reliably, and securely.
          </Typography>
          <Grid container spacing={2} sx={{ flexDirection: { xs: "column", sm: "row" } }}>
            <Button
              // onClick={() => navigate(`/questions/${otherDomain.toLowerCase()}`)}
              onClick={() => navigate(`/questions/devops`)}
              sx={{
                background: "#0036DD",
                color: "#FFF",
                padding: "0.5rem 1rem",
                borderRadius: "2rem",
                textTransform: "none",
                width: { xs: "100%", sm: "180px" },
                height: "32px",
                fontSize: "14px",
                fontFamily: "Akkurat",
              }}
            >
              Get Started
            </Button>
            <Button
              // onClick={() => navigate(`/questions/${otherDomain.toLowerCase()}`)}
              onClick={() =>
                navigate(
                  `/sre-score?evaluationId=${latestByDomain?.DEVOPS?.evaluationId}&domain=${encodeURIComponent(
                    domains[0],
                  )}&email=${encodeURIComponent(user.email)}&name=${encodeURIComponent(
                    user.name,
                  )}`,
                )
              }
              disabled={ latestByDomain?.DEVOPS?.evaluationId==undefined }
              sx={{
                background: latestByDomain?.DEVOPS?.evaluationId==undefined?"#FFF":"#0036DD",
                color: "#FFF",
                padding: "0.5rem 1rem",
                borderRadius: "2rem",
                textTransform: "none",
                width: { xs: "100%", sm: "180px" },
                height: "32px",
                fontSize: "14px",
                fontFamily: "Akkurat",
              }}
            >
              View Report
            </Button>
          </Grid>
        </Box>

        {/* ---------------- RIGHT CARD (Other Domain) ---------------- */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "0.8rem",
            padding: "1.25rem",
            borderRadius: "1rem",
            border: "1px solid #C0C7CF",
            backgroundColor: "#FFF",
            boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
          }}
        >
          {/* DOMAIN ICON */}
          <Box
            component="img"
            src={getDomainIcon("SRE")}
            alt={`SRE icon`}
            sx={getDomainIconStyle("SRE")}
          />

          <Typography
            sx={{
              fontFamily: "Akkurat-Bold",
              fontSize: { xs: "1.1rem", md: "24px" },
              fontWeight: 400,
              color: "#3C4044",
            }}
          >
            SRE Assessment
          </Typography>

          {/* <Typography
            sx={{
              fontFamily: "Akkurat",
              fontSize: "20px",
              fontWeight: 400,
              color: "#3C4044",
            }}
          >
            Start Site Reliability Engineering (SRE) assessment.
          </Typography> */}

          <Typography
            sx={{ fontSize: "14px", color: "#3C4044", fontFamily: "Akkurat" }}
          >
            The SRE Assessment measures the reliability, scalability,
            resilience, and observability posture of your production systems.
          </Typography>
          <Grid container spacing={2} sx={{ flexDirection: { xs: "column", sm: "row" } }}>
            <Button
              // onClick={() => navigate(`/questions/${otherDomain.toLowerCase()}`)}
              onClick={() => navigate(`/questions/sre`)}
              sx={{
                marginTop: "18px",
                background: "#0036DD",
                color: "#FFF",
                padding: "0.5rem 1rem",
                borderRadius: "2rem",
                textTransform: "none",
                width: { xs: "100%", sm: "180px" },
                height: "32px",
                fontSize: "14px",
                fontFamily: "Akkurat",
              }}
            >
              Get Started
            </Button>
            <Button
              onClick={() =>
                navigate(
                  `/sre-score?evaluationId=${latestByDomain?.SRE?.evaluationId}&domain=${encodeURIComponent(
                    domains[1],
                  )}&email=${encodeURIComponent(user.email)}&name=${encodeURIComponent(
                    user.name,
                  )}`,
                )
              }
              disabled={latestByDomain?.SRE?.evaluationId==undefined }

              sx={{
                marginTop: "18px",
                background: latestByDomain?.SRE?.evaluationId==undefined?"#FFF":"#0036DD",
                color: "#FFF",
                padding: "0.5rem 1rem ",
                borderRadius: "2rem",
                textTransform: "none",
                width: { xs: "100%", sm: "180px" },
                height: "32px",
                fontSize: "14px",
                fontFamily: "Akkurat",
              }}
            >
              View Report
            </Button>
          </Grid>
        </Box>
      </Box>
      {/* Instruction card */}
      <Box
        sx={{
          margin: "0px 16px",
          padding: "0.75rem 1.5rem",
          boxSizing: "border-box",
          borderBottom: "1px solid #D4D9E2",
          background: "#EDF0FD",
          mb: "1rem",
          borderRadius: "0.75rem",
          alignItems: "flex-start",
        }}
      >
        <Typography
          sx={{
            color: "#0036DD",
            fontSize: "1.05rem",
            fontWeight: 400,
            fontFamily: "Akkurat-Bold",
            pl: 1,
          }}
        >
        Instructions
        </Typography>
        <Typography
          sx={{
            color: "#000",
            fontSize: "0.75rem",
            fontWeight: 400,
            fontFamily: "Akkurat",
            pl: 1,
          }}
        >
          This portal help assess Maturity levels of an organizations as per
          below defined criteria.
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "flex-start",
          gap: "0.5rem",
          alignSelf: "stretch",
          padding: "20px 16px",
          borderRadius: "1rem",
          border: "1px solid #C0C7CF",
          backgroundColor: "#FFF",
          margin: "0px 16px 80px ",
          boxSizing: "border-box",
          boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
        }}
      >
        <Typography
          sx={{
            fontFamily: "Akkurat",
            fontSize: "0.875rem",
            color: "#000",
            fontWeight:400,
            marginLeft:"12px"
          }}
        >
          Maturity Levels
        </Typography>

        {/* Maturity Levels List */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "0.75rem",
            width: "100%",
          }}
        >
          {/* --- 1. Optimized --- */}
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              alignItems: { xs: "flex-start", sm: "center" },
              gap: "0.5rem",
              width: "100%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "0.25rem", // spacing/small-small
                width: "4.6875rem", // exact width
                padding: "0.25rem 0.5rem", // extra-small small-small
                borderRadius: "0.25rem",
                background: "#F5F6F8",
                color: "#0F62FE", // keep your text color
                fontSize: "0.75rem",
                fontFamily: "Akkurat",
                textAlign: "center",
              }}
            >
              Optimized
            </Box>

            <Typography
              sx={{ fontSize: "0.75rem", color: "#000", fontFamily: "Akkurat", flex: 1, minWidth: 0 }}
            >
              The system operates with peak efficiency, leveraging advanced
              DevOps methodologies and continuous security compliance.
            </Typography>
          </Box>

          {/* --- 2. Measured --- */}
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              alignItems: { xs: "flex-start", sm: "center" },
              gap: "0.5rem",
              width: "100%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "0.25rem", // spacing/small-small
                width: "4.6875rem", // exact width
                padding: "0.25rem 0.5rem", // extra-small small-small
                borderRadius: "0.25rem",
                background: "#F5F6F8",
                color: "#008200", // keep your text color
                fontSize: "0.75rem",
                fontFamily: "Akkurat",
                textAlign: "center",
              }}
            >
              Measured
            </Box>

            <Typography
              sx={{ fontSize: "0.75rem", color: "#000", fontFamily: "Akkurat", flex: 1, minWidth: 0 }}
            >
              Industry best practices are integrated with robust tooling and
              telemetry, enabling objective performance tracking.
            </Typography>
          </Box>

          {/* --- 3. Managed --- */}
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" }, // responsive
              alignItems: { xs: "flex-start", sm: "center" },
              gap: "0.5rem",
              width: "100%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "0.25rem", // spacing/small-small
                width: "4.6875rem", // exact width
                padding: "0.25rem 0.5rem", // extra-small small-small
                borderRadius: "0.25rem",
                background: "#F5F6F8",
                color: "#C89600", // keep your text color
                fontSize: "0.75rem",
                fontFamily: "Akkurat",
                textAlign: "center",
              }}
            >
              Managed
            </Box>

            <Typography
              sx={{
                fontSize: "0.75rem",
                color: "#000",
                fontFamily: "Akkurat",
              }}
            >
              Core best practices are present, but execution is inconsistent and
              requires structural maturity to scale.
            </Typography>
          </Box>

          {/* --- 4. Initial --- */}
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              alignItems: { xs: "flex-start", sm: "center" },
              gap: "0.5rem",
              width: "100%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "0.25rem", // spacing/small-small
                width: "4.6875rem", // exact width
                padding: "0.25rem 0.5rem", // extra-small small-small
                borderRadius: "0.25rem",
                background: "#F5F6F8",
                color: "#C71313", // keep your text color
                fontSize: "0.75rem",
                fontFamily: "Akkurat",
                textAlign: "center",
              }}
            >
              Initial
            </Box>

            <Typography
              sx={{ fontSize: "0.75rem", color: "#000", fontFamily: "Akkurat", flex: 1, minWidth: 0 }}
            >
              The environment lacks alignment with DevSecOps best practices,
              resulting in manual bottlenecks and high operational risk.
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}